module.exports = __webpack_public_path__ + "public/images/elephant.803a161f9bb88b2da67774bd61384439.png";